import './i18n/autoTranslate';
// // IssueReportPage.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   AlertTriangle,
//   BadgeCheck,
//   Bug,
//   ChevronRight,
//   ClipboardList,
//   FileText,
//   Gauge,
//   Layers,
//   Loader2,
//   MessageSquareText,
//   Search,
//   Send,
//   Sparkles,
//   Tag,
//   TriangleAlert,
//   Zap,
// } from "lucide-react";
// import AppBackground from "../components/ui/AppBackground.tsx";

// /**
//  * Premium “Report an Issue / Feedback” page for AppIssueReport table.
//  *
//  * Backend expectations (rename if you want):
//  * - POST   /api/issue-reports           -> create report (returns {id,...} or {report:{id,...}})
//  * - GET    /api/issue-reports/mine      -> list user reports
//  */

// const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5000';


// const REPORT_TYPES = [
//   { key: "bug", label: "Bug", icon: Bug, desc: "Something is broken or not working." },
//   { key: "feature", label: "Feature request", icon: Sparkles, desc: "New functionality you want." },
//   { key: "ux", label: "UX / UI feedback", icon: Layers, desc: "Improve layout, flow, or clarity." },
//   { key: "performance", label: "Performance", icon: Gauge, desc: "Slow, laggy, heavy, freezes." },
//   { key: "billing", label: "Billing", icon: Tag, desc: "Subscription / invoices / payments." },
//   { key: "content", label: "Content", icon: FileText, desc: "Text, questions, copy, translations." },
//   { key: "other", label: "Other", icon: MessageSquareText, desc: "Anything else." },
// ];

// const SEVERITIES = [
//   { key: "low", label: "Low", hint: "Minor annoyance, workaround exists." },
//   { key: "medium", label: "Medium", hint: "Affects workflow sometimes." },
//   { key: "high", label: "High", hint: "Blocks important actions." },
//   { key: "critical", label: "Critical", hint: "App unusable / billing broken / data loss." },
// ];

// const STATUSES = {
//   new: { label: "New", className: "bg-indigo-500/15 text-indigo-200 border-indigo-400/20" },
//   triaged: { label: "Triaged", className: "bg-cyan-500/15 text-cyan-200 border-cyan-400/20" },
//   in_progress: { label: "In progress", className: "bg-purple-500/15 text-purple-200 border-purple-400/20" },
//   needs_info: { label: "Needs info", className: "bg-amber-500/15 text-amber-200 border-amber-400/20" },
//   resolved: { label: "Resolved", className: "bg-emerald-500/15 text-emerald-200 border-emerald-400/20" },
//   closed: { label: "Closed", className: "bg-zinc-500/15 text-zinc-200 border-white/10" },
// };

// function cn(...classes) {
//   return classes.filter(Boolean).join(" ");
// }

// function getToken() {
//   try {
//     return (
//       localStorage.getItem("access_token") ||
//       localStorage.getItem("token") ||
//       sessionStorage.getItem("access_token") ||
//       sessionStorage.getItem("token") ||
//       ""
//     );
//   } catch {
//     return "";
//   }
// }

// function authHeaders() {
//   const token = getToken();
//   return {
//     "Content-Type": "application/json",
//     ...(token ? { Authorization: `Bearer ${token}` } : {}),
//   };
// }

// function safeDateLabel(val) {
//   if (!val) return "—";
//   const d = new Date(val);
//   if (Number.isNaN(d.getTime())) return "—";
//   return d.toLocaleString(undefined, {
//     year: "numeric",
//     month: "short",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// function hashFingerprint(str) {
//   let h = 2166136261;
//   for (let i = 0; i < str.length; i++) {
//     h ^= str.charCodeAt(i);
//     h = Math.imul(h, 16777619);
//   }
//   return ("0000000" + (h >>> 0).toString(16)).slice(-8);
// }

// function Pill({ children, className }) {
//   return (
//     <span
//       className={cn(
//         "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-wide",
//         "border-white/10 bg-white/5 text-white/75",
//         className
//       )}
//     >
//       {children}
//     </span>
//   );
// }

// function Card({ children, className }) {
//   return (
//     <div
//       className={cn(
//         "relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.06] to-transparent",
//         "shadow-[0_18px_60px_-36px_rgba(99,102,241,0.55)]",
//         className
//       )}
//     >
//       <div className="absolute inset-0 pointer-events-none">
//         <div className="absolute inset-0 opacity-[0.22] [background-image:radial-gradient(rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:22px_22px]" />
//         <div className="absolute -top-24 -left-24 h-[420px] w-[420px] rounded-full bg-indigo-400/10 blur-[90px]" />
//         <div className="absolute -bottom-28 -right-28 h-[520px] w-[520px] rounded-full bg-fuchsia-400/10 blur-[110px]" />
//       </div>
//       <div className="relative">{children}</div>
//     </div>
//   );
// }

// function Field({ label, hint, children, optional }) {
//   return (
//     <div className="space-y-2">
//       <div className="flex items-end justify-between gap-3">
//         <div>
//           <div className="flex items-center gap-2">
//             <div className="text-sm font-semibold text-white">{label}</div>
//             {optional && <Pill className="text-[10px] py-0.5">Optional</Pill>}
//           </div>
//           {hint && <div className="text-xs text-white/55 mt-0.5">{hint}</div>}
//         </div>
//       </div>
//       {children}
//     </div>
//   );
// }

// function Input({ className, ...props }) {
//   return (
//     <input
//       className={cn(
//         "h-11 w-full rounded-xl border border-white/10 bg-black/20 px-3 text-sm text-white",
//         "placeholder:text-white/35 outline-none",
//         "focus:border-indigo-400/30 focus:ring-2 focus:ring-indigo-500/15",
//         className
//       )}
//       {...props}
//     />
//   );
// }

// function Textarea({ className, ...props }) {
//   return (
//     <textarea
//       className={cn(
//         "min-h-[110px] w-full rounded-xl border border-white/10 bg-black/20 px-3 py-2.5 text-sm text-white",
//         "placeholder:text-white/35 outline-none",
//         "focus:border-indigo-400/30 focus:ring-2 focus:ring-indigo-500/15",
//         className
//       )}
//       {...props}
//     />
//   );
// }

// function Button({ className, variant = "primary", loading, children, ...props }) {
//   const base =
//     "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed";

//   const styles =
//     variant === "ghost"
//       ? "bg-white/0 hover:bg-white/5 text-white/75 hover:text-white border border-white/10"
//       : variant === "danger"
//       ? "bg-red-500/15 hover:bg-red-500/20 text-red-100 border border-red-400/20"
//       : "bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white border border-white/10 shadow-[0_16px_40px_-26px_rgba(99,102,241,0.95)]";

//   return (
//     <button className={cn(base, styles, className)} disabled={loading || props.disabled} {...props}>
//       {loading && <Loader2 className="h-4 w-4 animate-spin" />}
//       {children}
//     </button>
//   );
// }

// function ProgressRing({ value = 0 }) {
//   const size = 84;
//   const stroke = 8;
//   const r = (size - stroke) / 2;
//   const c = 2 * Math.PI * r;
//   const pct = Math.max(0, Math.min(100, value));
//   const dash = (pct / 100) * c;
//   return (
//     <div className="relative grid place-items-center">
//       <svg width={size} height={size} className="rotate-[-90deg]">
//         <circle cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} className="fill-none stroke-white/10" />
//         <circle
//           cx={size / 2}
//           cy={size / 2}
//           r={r}
//           strokeWidth={stroke}
//           strokeLinecap="round"
//           className="fill-none stroke-white/80"
//           style={{ strokeDasharray: `${dash} ${c - dash}` }}
//         />
//       </svg>
//       <div className="absolute text-center">
//         <div className="text-lg font-bold text-white">{pct}%</div>
//         <div className="text-[11px] text-white/55 -mt-0.5">quality</div>
//       </div>
//     </div>
//   );
// }

// function StepPills({ step, setStep }) {
//   const items = [
//     { i: 1, label: "Type" },
//     { i: 2, label: "Describe" },
//     { i: 3, label: "Reproduce" },
//     { i: 4, label: "Review" },
//   ];
//   return (
//     <div className="flex flex-wrap items-center gap-2">
//       {items.map((it) => (
//         <button
//           key={it.i}
//           onClick={() => setStep(it.i)}
//           className={cn(
//             "rounded-full border px-3 py-1.5 text-xs font-semibold transition",
//             step === it.i
//               ? "bg-white/10 border-white/15 text-white"
//               : "bg-white/0 border-white/10 text-white/60 hover:text-white hover:bg-white/5"
//           )}
//         >
//           <span className="mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-black/30 border border-white/10 text-[11px]">
//             {it.i}
//           </span>
//           {it.label}
//         </button>
//       ))}
//     </div>
//   );
// }

// function StatusChip({ status }) {
//   const s = (status || "new").toString();
//   const meta = STATUSES[s] || STATUSES.new;
//   return (
//     <span className={cn("inline-flex items-center rounded-full border px-2 py-1 text-[11px] font-semibold", meta.className)}>
//       {meta.label}
//     </span>
//   );
// }

// export default function IssueReportPage() {
//   const location = useLocation();

//   // If you have user in redux; else it still works (email/name fields stay editable)
//   const user = useSelector((state) => state?.auth?.user);

//   const [tab, setTab] = useState("new"); // new | mine
//   const [step, setStep] = useState(1);

//   // Mine
//   const [myLoading, setMyLoading] = useState(false);
//   const [myReports, setMyReports] = useState([]);
//   const [q, setQ] = useState("");
//   const [selected, setSelected] = useState(null);

//   // Form
//   const [submitting, setSubmitting] = useState(false);
//   const [success, setSuccess] = useState(null);

//   const [form, setForm] = useState({
//     report_type: "bug",
//     severity: "medium",
//     title: "",
//     description: "",
//     steps_to_reproduce: "",
//     expected_behavior: "",
//     actual_behavior: "",
//     feature_area: "",
//     full_name: "",
//     email: "",
//     environment: (import.meta?.env?.MODE || "production") + "",
//     app_version: (import.meta?.env?.VITE_APP_VERSION || "").toString(),
//   });

//   // auto-fill email/name once
//   useEffect(() => {
//     setForm((p) => ({
//       ...p,
//       full_name: p.full_name || (user?.first_name ? `${user?.first_name} ${user?.last_name || ""}`.trim() : ""),
//       email: p.email || (user?.email || ""),
//     }));
//   }, [user?.email, user?.first_name, user?.last_name]);

//   const page_url = typeof window !== "undefined" ? window.location.href : "";
//   const route = location?.pathname || "";

//   const context_json = useMemo(() => {
//     const w = typeof window !== "undefined" ? window : null;
//     return {
//       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       locale: (navigator?.language || "").toString(),
//       screen: w ? { width: w.screen?.width, height: w.screen?.height } : null,
//       viewport: w ? { width: w.innerWidth, height: w.innerHeight } : null,
//       referrer: (document?.referrer || "").toString(),
//     };
//   }, []);

//   const qualityScore = useMemo(() => {
//     let score = 0;
//     if (form.title.trim().length >= 10) score += 25;
//     if (form.description.trim().length >= 30) score += 25;
//     if (form.steps_to_reproduce.trim().length >= 20) score += 20;
//     if (form.expected_behavior.trim().length >= 10) score += 15;
//     if (form.actual_behavior.trim().length >= 10) score += 15;
//     return Math.min(100, score);
//   }, [form]);

//   const fingerprint = useMemo(() => {
//     const base = [
//       form.report_type,
//       form.feature_area,
//       route,
//       form.title.trim().toLowerCase(),
//       (form.description || "").trim().toLowerCase().slice(0, 120),
//     ].join("|");
//     return hashFingerprint(base);
//   }, [form.report_type, form.feature_area, route, form.title, form.description]);

//   async function loadMine() {
//     setMyLoading(true);
//     try {
//       const res = await fetch(`${API_BASE}/api/issue-reports/mine`, {
//         method: "GET",
//         headers: authHeaders(),
//         credentials: "include",
//       });
//       if (!res.ok) {
//         setMyReports([]);
//         setMyLoading(false);
//         return;
//       }
//       const data = await res.json();
//       const list = data.reports || data.items || data.data || data || [];
//       setMyReports(Array.isArray(list) ? list : []);
//       setMyLoading(false);
//     } catch {
//       setMyReports([]);
//       setMyLoading(false);
//     }
//   }

//   useEffect(() => {
//     if (tab === "mine") loadMine();
//   }, [tab]);

//   const filteredMine = useMemo(() => {
//     const query = q.trim().toLowerCase();
//     const list = Array.isArray(myReports) ? myReports : [];
//     if (!query) return list;
//     return list.filter((r) => {
//       const s = `${r.title || ""} ${r.description || ""} ${r.report_type || ""} ${r.severity || ""} ${r.status || ""}`.toLowerCase();
//       return s.includes(query);
//     });
//   }, [myReports, q]);

//   const similar = useMemo(() => {
//     if (!Array.isArray(myReports) || myReports.length === 0) return [];
//     const key = (form.title || "").trim().toLowerCase();
//     if (key.length < 6) return [];
//     return myReports
//       .filter((r) => (r.title || "").toLowerCase().includes(key.slice(0, 6)) || r.fingerprint === fingerprint)
//       .slice(0, 2);
//   }, [myReports, form.title, fingerprint]);

//   function update(k, v) {
//     setForm((p) => ({ ...p, [k]: v }));
//   }

//   async function submit() {
//     setSubmitting(true);
//     try {
//       const payload = {
//         user_id: user.id || null,
//         full_name: form.full_name || null,
//         email: form.email || null,
//         report_type: form.report_type,
//         severity: form.severity,
//         title: form.title.trim(),
//         description: form.description.trim(),
//         steps_to_reproduce: form.steps_to_reproduce.trim() || null,
//         expected_behavior: form.expected_behavior.trim() || null,
//         actual_behavior: form.actual_behavior.trim() || null,
//         feature_area: form.feature_area.trim() || null,
//         page_url,
//         route,
//         environment: form.environment || "production",
//         app_version: form.app_version || null,
//         user_agent: (navigator?.userAgent || "").toString(),
//         context_json,
//         fingerprint,
//       };

//       const res = await fetch(`${API_BASE}/api/issue-reports`, {
//         method: "POST",
//         headers: authHeaders(),
//         credentials: "include",
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) {
//         const err = await res.json().catch(() => ({}));
//         throw new Error(err.message || "Failed to submit report");
//       }

//       const data = await res.json().catch(() => ({}));
//       const report = data.report || data.data || data;
//       const reportId = report?.id || data?.id || null;

//       setSuccess({ id: reportId, fingerprint });

//       setForm((p) => ({
//         ...p,
//         title: "",
//         description: "",
//         steps_to_reproduce: "",
//         expected_behavior: "",
//         actual_behavior: "",
//       }));
//       setStep(1);
//       setSubmitting(false);

//       loadMine();
//     } catch (e) {
//       setSubmitting(false);
//       alert(e?.message || "Something went wrong");
//     }
//   }

//   const canNextFromStep1 = !!form.report_type && !!form.severity;
//   const canNextFromStep2 = form.title.trim().length >= 6 && form.description.trim().length >= 20;

//   return (
//     <AppBackground className="min-h-screen bg-[#0B0B12] text-white">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
//         <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
//           <div className="space-y-2">
//             <div className="inline-flex items-center gap-2">
//               <div className="h-10 w-10 rounded-2xl border border-white/10 bg-white/5 grid place-items-center">
//                 <TriangleAlert className="h-5 w-5 text-indigo-300" />
//               </div>
//               <div>
//                 <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight">
//                   Report an issue <span className="text-white/40">or</span> share feedback
//                 </h1>
//                 <p className="text-white/55 text-sm md:text-base">
//                   Help us improve InterviewGenieAI. Your report is structured, tracked, and visible in your history.
//                 </p>
//               </div>
//             </div>
//             <div className="flex flex-wrap items-center gap-2">
//               <Pill><ClipboardList className="h-3.5 w-3.5" />Smart report format</Pill>
//               <Pill><Zap className="h-3.5 w-3.5" />Auto context captured</Pill>
//               <Pill><BadgeCheck className="h-3.5 w-3.5" />Status tracking</Pill>
//             </div>
//           </div>

//           <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-black/20 p-1.5">
//             <button
//               onClick={() => setTab("new")}
//               className={cn("rounded-xl px-4 py-2 text-sm font-semibold transition", tab === "new" ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5")}
//             >
//               New report
//             </button>
//             <button
//               onClick={() => setTab("mine")}
//               className={cn("rounded-xl px-4 py-2 text-sm font-semibold transition", tab === "mine" ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5")}
//             >
//               My reports
//             </button>
//           </div>
//         </div>

//         {tab === "mine" ? (
//           <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
//             <Card className="lg:col-span-5">
//               <div className="p-5 border-b border-white/10 flex items-center justify-between gap-3">
//                 <div className="space-y-1">
//                   <div className="text-sm font-semibold text-white">My reports</div>
//                   <div className="text-xs text-white/55">Search, open details, and track status.</div>
//                 </div>
//                 <Button variant="ghost" onClick={loadMine} disabled={myLoading}>
//                   {myLoading ? "Refreshing…" : "Refresh"}
//                 </Button>
//               </div>

//               <div className="p-5">
//                 <div className="relative">
//                   <Search className="h-4 w-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
//                   <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by title, status, type…" className="pl-9" />
//                 </div>

//                 <div className="mt-4 space-y-3">
//                   {myLoading ? (
//                     <div className="text-white/60 text-sm flex items-center gap-2">
//                       <Loader2 className="h-4 w-4 animate-spin" />
//                       Loading…
//                     </div>
//                   ) : filteredMine.length === 0 ? (
//                     <div className="rounded-2xl border border-white/10 bg-white/5 p-4 text-sm text-white/70">
//                       No reports yet. Create your first one from <button className="underline" onClick={() => setTab("new")}>New report</button>.
//                     </div>
//                   ) : (
//                     filteredMine.map((r) => (
//                       <button
//                         key={r.id || r.fingerprint || Math.random()}
//                         onClick={() => setSelected(r)}
//                         className={cn("w-full text-left rounded-2xl border border-white/10 bg-black/20 hover:bg-white/5 transition p-4", selected?.id === r.id ? "ring-2 ring-indigo-500/20" : "")}
//                       >
//                         <div className="flex items-start justify-between gap-3">
//                           <div className="min-w-0">
//                             <div className="text-sm font-semibold text-white truncate">{r.title || "Untitled report"}</div>
//                             <div className="mt-1 text-xs text-white/55 line-clamp-2">{r.description || ""}</div>
//                           </div>
//                           <div className="flex flex-col items-end gap-2 shrink-0">
//                             <StatusChip status={r.status} />
//                             <Pill className="text-[10px] py-0.5">{(r.severity || "medium").toUpperCase()}</Pill>
//                           </div>
//                         </div>
//                         <div className="mt-3 flex items-center justify-between text-xs text-white/45">
//                           <div className="flex items-center gap-2">
//                             <Pill className="bg-white/0">{(r.report_type || "other").toUpperCase()}</Pill>
//                             {r.feature_area && <Pill className="bg-white/0">{r.feature_area}</Pill>}
//                           </div>
//                           <div>{safeDateLabel(r.created_at)}</div>
//                         </div>
//                       </button>
//                     ))
//                   )}
//                 </div>
//               </div>
//             </Card>

//             <Card className="lg:col-span-7">
//               <div className="p-5 border-b border-white/10 flex items-center justify-between">
//                 <div className="space-y-1">
//                   <div className="text-sm font-semibold text-white">Details</div>
//                   <div className="text-xs text-white/55">Full report info and progress.</div>
//                 </div>
//                 <Button variant="primary" onClick={() => setTab("new")}>
//                   New report <ChevronRight className="h-4 w-4" />
//                 </Button>
//               </div>

//               <div className="p-6">
//                 {!selected ? (
//                   <div className="rounded-2xl border border-white/10 bg-white/5 p-6 text-sm text-white/70">
//                     Select a report on the left to view details.
//                   </div>
//                 ) : (
//                   <div className="space-y-5">
//                     <div className="flex items-start justify-between gap-4">
//                       <div className="min-w-0">
//                         <div className="text-xl font-extrabold text-white">{selected.title}</div>
//                         <div className="mt-2 text-sm text-white/65 whitespace-pre-wrap">{selected.description}</div>
//                       </div>
//                       <div className="flex flex-col items-end gap-2 shrink-0">
//                         <StatusChip status={selected.status} />
//                         <Pill className="bg-white/0">{(selected.report_type || "other").toUpperCase()}</Pill>
//                         <Pill className="bg-white/0">{(selected.severity || "medium").toUpperCase()}</Pill>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                       <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
//                         <div className="text-xs text-white/55">Created</div>
//                         <div className="mt-1 text-sm font-semibold text-white">{safeDateLabel(selected.created_at)}</div>
//                       </div>
//                       <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
//                         <div className="text-xs text-white/55">Feature area</div>
//                         <div className="mt-1 text-sm font-semibold text-white">{selected.feature_area || "—"}</div>
//                       </div>
//                       <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
//                         <div className="text-xs text-white/55">Route</div>
//                         <div className="mt-1 text-sm font-semibold text-white break-all">{selected.route || "—"}</div>
//                       </div>
//                       <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
//                         <div className="text-xs text-white/55">Resolved</div>
//                         <div className="mt-1 text-sm font-semibold text-white">{safeDateLabel(selected.resolved_at)}</div>
//                       </div>
//                     </div>

//                     {(selected.steps_to_reproduce || selected.expected_behavior || selected.actual_behavior) && (
//                       <div className="rounded-2xl border border-white/10 bg-black/20 p-4 space-y-3">
//                         {selected.steps_to_reproduce && (
//                           <div>
//                             <div className="text-xs font-semibold text-white/75">Steps</div>
//                             <div className="mt-1 text-sm text-white/65 whitespace-pre-wrap">{selected.steps_to_reproduce}</div>
//                           </div>
//                         )}
//                         {selected.expected_behavior && (
//                           <div>
//                             <div className="text-xs font-semibold text-white/75">Expected</div>
//                             <div className="mt-1 text-sm text-white/65 whitespace-pre-wrap">{selected.expected_behavior}</div>
//                           </div>
//                         )}
//                         {selected.actual_behavior && (
//                           <div>
//                             <div className="text-xs font-semibold text-white/75">Actual</div>
//                             <div className="mt-1 text-sm text-white/65 whitespace-pre-wrap">{selected.actual_behavior}</div>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {selected.admin_notes && (
//                       <div className="rounded-2xl border border-emerald-400/20 bg-emerald-500/10 p-4">
//                         <div className="text-xs font-semibold text-emerald-200">Team note</div>
//                         <div className="mt-1 text-sm text-emerald-100/90 whitespace-pre-wrap">{selected.admin_notes}</div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </Card>
//           </div>
//         ) : (
//           <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
//             <Card className="lg:col-span-7">
//               <div className="p-5 border-b border-white/10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
//                 <div className="space-y-1">
//                   <div className="text-sm font-semibold text-white">Create a report</div>
//                   <div className="text-xs text-white/55">Clear reports = faster fixes. We capture context automatically.</div>
//                 </div>
//                 <StepPills step={step} setStep={setStep} />
//               </div>

//               <div className="p-6 space-y-6">
//                 {success && (
//                   <div className="rounded-2xl border border-emerald-400/20 bg-emerald-500/10 p-4 flex items-start justify-between gap-3">
//                     <div className="flex items-start gap-3">
//                       <div className="h-10 w-10 rounded-2xl bg-emerald-500/15 border border-emerald-400/20 grid place-items-center">
//                         <BadgeCheck className="h-5 w-5 text-emerald-200" />
//                       </div>
//                       <div>
//                         <div className="text-sm font-semibold text-emerald-100">Submitted successfully</div>
//                         <div className="text-xs text-emerald-100/80 mt-1">
//                           Report ID: <span className="font-semibold">{success.id ?? "—"}</span> • Fingerprint: <span className="font-semibold">{success.fingerprint}</span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <Button variant="ghost" onClick={() => setSuccess(null)}>Dismiss</Button>
//                       <Button onClick={() => setTab("mine")}>View history <ChevronRight className="h-4 w-4" /></Button>
//                     </div>
//                   </div>
//                 )}

//                 {step === 1 && (
//                   <div className="space-y-6">
//                     <Field label="What kind of report is this?" hint="Choose the best category. It helps triage.">
//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                         {REPORT_TYPES.map((t) => {
//                           const Icon = t.icon;
//                           const active = form.report_type === t.key;
//                           return (
//                             <button
//                               key={t.key}
//                               onClick={() => update("report_type", t.key)}
//                               className={cn(
//                                 "text-left rounded-2xl border p-4 transition",
//                                 active
//                                   ? "border-indigo-400/30 bg-indigo-500/10 shadow-[0_18px_60px_-40px_rgba(99,102,241,0.65)]"
//                                   : "border-white/10 bg-black/20 hover:bg-white/5"
//                               )}
//                             >
//                               <div className="flex items-start justify-between gap-3">
//                                 <div className="flex items-start gap-3">
//                                   <div className={cn("h-10 w-10 rounded-2xl grid place-items-center border", active ? "bg-indigo-500/15 border-indigo-400/20" : "bg-white/5 border-white/10")}>
//                                     <Icon className={cn("h-5 w-5", active ? "text-indigo-200" : "text-white/70")} />
//                                   </div>
//                                   <div>
//                                     <div className="text-sm font-semibold text-white">{t.label}</div>
//                                     <div className="text-xs text-white/55 mt-1">{t.desc}</div>
//                                   </div>
//                                 </div>
//                                 {active && <BadgeCheck className="h-5 w-5 text-indigo-200" />}
//                               </div>
//                             </button>
//                           );
//                         })}
//                       </div>
//                     </Field>

//                     <Field label="Severity" hint="How much does this impact you?">
//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                         {SEVERITIES.map((s) => {
//                           const active = form.severity === s.key;
//                           return (
//                             <button
//                               key={s.key}
//                               onClick={() => update("severity", s.key)}
//                               className={cn("text-left rounded-2xl border p-4 transition", active ? "border-white/15 bg-white/10" : "border-white/10 bg-black/20 hover:bg-white/5")}
//                             >
//                               <div className="flex items-start justify-between gap-3">
//                                 <div>
//                                   <div className="text-sm font-semibold text-white">{s.label}</div>
//                                   <div className="text-xs text-white/55 mt-1">{s.hint}</div>
//                                 </div>
//                                 {active && <BadgeCheck className="h-5 w-5 text-white/80" />}
//                               </div>
//                             </button>
//                           );
//                         })}
//                       </div>
//                     </Field>

//                     <div className="flex items-center justify-end gap-2 pt-2">
//                       <Button variant="ghost" onClick={() => setTab("mine")}>View my reports</Button>
//                       <Button onClick={() => setStep(2)} disabled={!canNextFromStep1}>Continue <ChevronRight className="h-4 w-4" /></Button>
//                     </div>
//                   </div>
//                 )}

//                 {step === 2 && (
//                   <div className="space-y-6">
//                     <Field label="Title" hint="Short and specific. Example: “PayPal popup closes after login on Safari”.">
//                       <Input value={form.title} onChange={(e) => update("title", e.target.value)} placeholder="Give it a clear title…" />
//                     </Field>

//                     <Field label="Description" hint="Explain what happened in 2–6 lines. Include what you were trying to do.">
//                       <Textarea value={form.description} onChange={(e) => update("description", e.target.value)} placeholder="Describe the issue or feedback…" />
//                     </Field>

//                     <Field label="Feature area" hint="Optional but helpful. Example: “billing”, “ai-interview”, “resume-builder”." optional>
//                       <Input value={form.feature_area} onChange={(e) => update("feature_area", e.target.value)} placeholder="billing / ai-interview / resume-builder …" />
//                     </Field>

//                     {similar.length > 0 && (
//                       <div className="rounded-2xl border border-amber-400/20 bg-amber-500/10 p-4">
//                         <div className="flex items-start gap-3">
//                           <div className="h-10 w-10 rounded-2xl bg-amber-500/15 border border-amber-400/20 grid place-items-center">
//                             <AlertTriangle className="h-5 w-5 text-amber-200" />
//                           </div>
//                           <div className="min-w-0">
//                             <div className="text-sm font-semibold text-amber-100">Looks similar to a previous report</div>
//                             <div className="text-xs text-amber-100/80 mt-1">If it’s the same, add new details (device, steps, etc.) to help.</div>
//                             <div className="mt-3 space-y-2">
//                               {similar.map((r) => (
//                                 <button
//                                   key={r.id}
//                                   onClick={() => { setTab("mine"); setSelected(r); }}
//                                   className="w-full text-left rounded-xl border border-amber-400/15 bg-black/20 hover:bg-white/5 transition p-3"
//                                 >
//                                   <div className="flex items-start justify-between gap-3">
//                                     <div className="min-w-0">
//                                       <div className="text-sm font-semibold text-white truncate">{r.title}</div>
//                                       <div className="text-xs text-white/55 mt-1 line-clamp-1">{r.description}</div>
//                                     </div>
//                                     <StatusChip status={r.status} />
//                                   </div>
//                                 </button>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}

//                     <div className="flex items-center justify-between gap-2 pt-2">
//                       <Button variant="ghost" onClick={() => setStep(1)}>Back</Button>
//                       <Button onClick={() => setStep(3)} disabled={!canNextFromStep2}>Continue <ChevronRight className="h-4 w-4" /></Button>
//                     </div>
//                   </div>
//                 )}

//                 {step === 3 && (
//                   <div className="space-y-6">
//                     <Field label="Steps to reproduce" hint="Bullet steps. Example: 1) Go to Billing 2) Click Upgrade 3) …" optional>
//                       <Textarea value={form.steps_to_reproduce} onChange={(e) => update("steps_to_reproduce", e.target.value)} placeholder={"1) …\n2) …\n3) …"} />
//                     </Field>

//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <Field label="Expected behavior" hint="What should happen?" optional>
//                         <Textarea value={form.expected_behavior} onChange={(e) => update("expected_behavior", e.target.value)} placeholder="Expected…" className="min-h-[120px]" />
//                       </Field>
//                       <Field label="Actual behavior" hint="What happened instead?" optional>
//                         <Textarea value={form.actual_behavior} onChange={(e) => update("actual_behavior", e.target.value)} placeholder="Actual…" className="min-h-[120px]" />
//                       </Field>
//                     </div>

//                     <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
//                       <div className="text-sm font-semibold text-white">Auto-captured context</div>
//                       <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-xs text-white/60">
//                         <div className="rounded-xl border border-white/10 bg-white/5 p-3">
//                           <div className="text-white/70 font-semibold">Route</div>
//                           <div className="mt-1 break-all">{route || "—"}</div>
//                         </div>
//                         <div className="rounded-xl border border-white/10 bg-white/5 p-3">
//                           <div className="text-white/70 font-semibold">Page URL</div>
//                           <div className="mt-1 break-all">{page_url || "—"}</div>
//                         </div>
//                         <div className="rounded-xl border border-white/10 bg-white/5 p-3">
//                           <div className="text-white/70 font-semibold">Timezone / Locale</div>
//                           <div className="mt-1">{context_json.timezone} • {context_json.locale}</div>
//                         </div>
//                         <div className="rounded-xl border border-white/10 bg-white/5 p-3">
//                           <div className="text-white/70 font-semibold">Fingerprint</div>
//                           <div className="mt-1 font-mono">{fingerprint}</div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="flex items-center justify-between gap-2 pt-2">
//                       <Button variant="ghost" onClick={() => setStep(2)}>Back</Button>
//                       <Button onClick={() => setStep(4)}>Continue <ChevronRight className="h-4 w-4" /></Button>
//                     </div>
//                   </div>
//                 )}

//                 {step === 4 && (
//                   <div className="space-y-6">
//                     <div className="rounded-2xl border border-white/10 bg-black/20 p-5">
//                       <div className="flex items-start justify-between gap-3">
//                         <div>
//                           <div className="text-sm font-semibold text-white">Review</div>
//                           <div className="text-xs text-white/55 mt-1">Better details = faster fix.</div>
//                         </div>
//                         <Pill className="font-mono">{fingerprint}</Pill>
//                       </div>

//                       <div className="mt-4 space-y-3">
//                         <div className="flex flex-wrap items-center gap-2">
//                           <Pill className="bg-white/0">{form.report_type.toUpperCase()}</Pill>
//                           <Pill className="bg-white/0">{form.severity.toUpperCase()}</Pill>
//                           {form.feature_area && <Pill className="bg-white/0">{form.feature_area}</Pill>}
//                         </div>

//                         <div className="text-lg font-extrabold text-white">{form.title || "—"}</div>
//                         <div className="text-sm text-white/65 whitespace-pre-wrap">{form.description || "—"}</div>
//                       </div>
//                     </div>

//                     <div className="rounded-2xl border border-white/10 bg-black/20 p-5">
//                       <div className="flex items-start justify-between gap-3">
//                         <div>
//                           <div className="text-sm font-semibold text-white">Contact (optional)</div>
//                           <div className="text-xs text-white/55 mt-1">If you want us to reply, keep email.</div>
//                         </div>
//                         <Pill className="bg-white/0">Optional</Pill>
//                       </div>

//                       <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
//                         <Field label="Full name" optional>
//                           <Input value={form.full_name} onChange={(e) => update("full_name", e.target.value)} placeholder="Your name" />
//                         </Field>
//                         <Field label="Email" optional>
//                           <Input value={form.email} onChange={(e) => update("email", e.target.value)} placeholder="you@example.com" />
//                         </Field>
//                       </div>
//                     </div>

//                     <div className="flex items-center justify-between gap-2 pt-2">
//                       <Button variant="ghost" onClick={() => setStep(3)}>Back</Button>
//                       <Button loading={submitting} onClick={submit} disabled={submitting || form.title.trim().length < 6 || form.description.trim().length < 20}>
//                         Submit report <Send className="h-4 w-4" />
//                       </Button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </Card>

//             <div className="lg:col-span-5 space-y-6">
//               <Card>
//                 <div className="p-5 border-b border-white/10 flex items-center justify-between gap-3">
//                   <div className="space-y-1">
//                     <div className="text-sm font-semibold text-white">Report quality</div>
//                     <div className="text-xs text-white/55">Higher quality = faster resolution.</div>
//                   </div>
//                   <Pill className="font-mono">{fingerprint}</Pill>
//                 </div>
//                 <div className="p-6 flex items-center gap-6">
//                   <ProgressRing value={qualityScore} />
//                   <div className="space-y-2">
//                     <div className="text-sm font-semibold text-white">Tips</div>
//                     <div className="text-xs text-white/60 space-y-1">
//                       <div className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-indigo-400/80" /><span>Add steps + expected/actual to boost clarity.</span></div>
//                       <div className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-indigo-400/80" /><span>Mention device/browser if it matters.</span></div>
//                       <div className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-indigo-400/80" /><span>Keep title short + specific.</span></div>
//                     </div>
//                   </div>
//                 </div>
//               </Card>

//               <Card>
//                 <div className="p-5 border-b border-white/10">
//                   <div className="text-sm font-semibold text-white">What we capture automatically</div>
//                   <div className="text-xs text-white/55 mt-1">So you don’t have to write everything.</div>
//                 </div>
//                 <div className="p-5 space-y-3 text-sm text-white/70">
//                   <div className="flex items-center justify-between gap-3">
//                     <div className="flex items-center gap-2"><Pill className="bg-white/0">Route</Pill><span className="text-white/60 truncate">{route || "—"}</span></div>
//                     <Pill className="bg-white/0">OK</Pill>
//                   </div>
//                   <div className="flex items-center justify-between gap-3">
//                     <div className="flex items-center gap-2"><Pill className="bg-white/0">Timezone</Pill><span className="text-white/60 truncate">{context_json.timezone}</span></div>
//                     <Pill className="bg-white/0">OK</Pill>
//                   </div>
//                   <div className="flex items-center justify-between gap-3">
//                     <div className="flex items-center gap-2"><Pill className="bg-white/0">Device</Pill><span className="text-white/60 truncate">{context_json.viewport?.width}×{context_json.viewport?.height}</span></div>
//                     <Pill className="bg-white/0">OK</Pill>
//                   </div>

//                   <div className="rounded-2xl border border-white/10 bg-white/5 p-4 text-xs text-white/60">
//                     <span className="font-semibold text-white/80">Privacy:</span> don’t include passwords, API keys, or private data.
//                   </div>
//                 </div>
//               </Card>

//               <div className="flex items-center justify-between">
//                 <Link to="/dashboard-home" className="text-sm text-white/60 hover:text-white transition">← Back to dashboard</Link>
//                 <Button variant="ghost" onClick={() => setTab("mine")}>My reports <ChevronRight className="h-4 w-4" /></Button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </AppBackground>
//   );
// }

// IssueReportPage.fixed.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AlertTriangle,
  BadgeCheck,
  Bug,
  ChevronRight,
  ClipboardList,
  FileText,
  Gauge,
  Layers,
  Loader2,
  MessageSquareText,
  Search,
  Send,
  Sparkles,
  Tag,
  TriangleAlert,
  Zap,
} from "lucide-react";
import AppBackground from "../components/ui/AppBackground.tsx";

/**
 * Premium “Report an Issue / Feedback” page for AppIssueReport table.
 *
 * Backend expectations:
 * - POST   /api/issue-reports           -> create report (returns {report:{...}} or {...})
 * - GET    /api/issue-reports/mine      -> list user reports (returns {reports:[...], total,...})
 *
 * UX upgrades included:
 * - No random keys (stable rendering)
 * - Auth-aware: if user isn't logged in, "My reports" shows a clean CTA (since /mine requires auth)
 * - Submit errors render in-page (no alert)
 * - Step pills can't jump forward past validated steps
 * - Safer API_BASE (no trailing slash double-slashes)
 */

const API_BASE =
  (import.meta.env.VITE_API_URL || "").replace(/\/$/, "") || "http://localhost:5000";

const REPORT_TYPES = [
  { key: "bug", label: "Bug", icon: Bug, desc: "Something is broken or not working." },
  { key: "feature", label: "Feature request", icon: Sparkles, desc: "New functionality you want." },
  { key: "ux", label: "UX / UI feedback", icon: Layers, desc: "Improve layout, flow, or clarity." },
  { key: "performance", label: "Performance", icon: Gauge, desc: "Slow, laggy, heavy, freezes." },
  { key: "billing", label: "Billing", icon: Tag, desc: "Subscription / invoices / payments." },
  { key: "content", label: "Content", icon: FileText, desc: "Text, questions, copy, translations." },
  { key: "other", label: "Other", icon: MessageSquareText, desc: "Anything else." },
];

const SEVERITIES = [
  { key: "low", label: "Low", hint: "Minor annoyance, workaround exists." },
  { key: "medium", label: "Medium", hint: "Affects workflow sometimes." },
  { key: "high", label: "High", hint: "Blocks important actions." },
  { key: "critical", label: "Critical", hint: "App unusable / billing broken / data loss." },
];

const STATUSES = {
  new: { label: "New", className: "bg-indigo-500/15 text-indigo-200 border-indigo-400/20" },
  triaged: { label: "Triaged", className: "bg-cyan-500/15 text-cyan-200 border-cyan-400/20" },
  in_progress: { label: "In progress", className: "bg-purple-500/15 text-purple-200 border-purple-400/20" },
  needs_info: { label: "Needs info", className: "bg-amber-500/15 text-amber-200 border-amber-400/20" },
  resolved: { label: "Resolved", className: "bg-emerald-500/15 text-emerald-200 border-emerald-400/20" },
  closed: { label: "Closed", className: "bg-zinc-500/15 text-zinc-200 border-white/10" },
};

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function getToken() {
  try {
    return (
      localStorage.getItem("access_token") ||
      localStorage.getItem("token") ||
      sessionStorage.getItem("access_token") ||
      sessionStorage.getItem("token") ||
      ""
    );
  } catch {
    return "";
  }
}

function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

function safeDateLabel(val) {
  if (!val) return "—";
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function hashFingerprint(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return ("0000000" + (h >>> 0).toString(16)).slice(-8);
}

function Pill({ children, className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-wide",
        "border-white/10 bg-white/5 text-white/75",
        className
      )}
    >
      {children}
    </span>
  );
}

function Card({ children, className }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.06] to-transparent",
        "shadow-[0_18px_60px_-36px_rgba(99,102,241,0.55)]",
        className
      )}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 opacity-[0.22] [background-image:radial-gradient(rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:22px_22px]" />
        <div className="absolute -top-24 -left-24 h-[420px] w-[420px] rounded-full bg-indigo-400/10 blur-[90px]" />
        <div className="absolute -bottom-28 -right-28 h-[520px] w-[520px] rounded-full bg-fuchsia-400/10 blur-[110px]" />
      </div>
      <div className="relative">{children}</div>
    </div>
  );
}

function Field({ label, hint, children, optional }) {
  return (
    <div className="space-y-2">
      <div className="flex items-end justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <div className="text-sm font-semibold text-white">{label}</div>
            {optional && <Pill className="text-[10px] py-0.5">Optional</Pill>}
          </div>
          {hint && <div className="text-xs text-white/55 mt-0.5">{hint}</div>}
        </div>
      </div>
      {children}
    </div>
  );
}

function Input({ className, ...props }) {
  return (
    <input
      className={cn(
        "h-11 w-full rounded-xl border border-white/10 bg-black/20 px-3 text-sm text-white",
        "placeholder:text-white/35 outline-none",
        "focus:border-indigo-400/30 focus:ring-2 focus:ring-indigo-500/15",
        className
      )}
      {...props}
    />
  );
}

function Textarea({ className, ...props }) {
  return (
    <textarea
      className={cn(
        "min-h-[110px] w-full rounded-xl border border-white/10 bg-black/20 px-3 py-2.5 text-sm text-white",
        "placeholder:text-white/35 outline-none",
        "focus:border-indigo-400/30 focus:ring-2 focus:ring-indigo-500/15",
        className
      )}
      {...props}
    />
  );
}

function Button({ className, variant = "primary", loading, children, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed";

  const styles =
    variant === "ghost"
      ? "bg-white/0 hover:bg-white/5 text-white/75 hover:text-white border border-white/10"
      : variant === "danger"
      ? "bg-red-500/15 hover:bg-red-500/20 text-red-100 border border-red-400/20"
      : "bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white border border-white/10 shadow-[0_16px_40px_-26px_rgba(99,102,241,0.95)]";

  return (
    <button className={cn(base, styles, className)} disabled={loading || props.disabled} {...props}>
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
}

function ProgressRing({ value = 0 }) {
  const size = 84;
  const stroke = 8;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value));
  const dash = (pct / 100) * c;
  return (
    <div className="relative grid place-items-center">
      <svg width={size} height={size} className="rotate-[-90deg]">
        <circle cx={size / 2} cy={size / 2} r={r} strokeWidth={stroke} className="fill-none stroke-white/10" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          strokeWidth={stroke}
          strokeLinecap="round"
          className="fill-none stroke-white/80"
          style={{ strokeDasharray: `${dash} ${c - dash}` }}
        />
      </svg>
      <div className="absolute text-center">
        <div className="text-lg font-bold text-white">{pct}%</div>
        <div className="text-[11px] text-white/55 -mt-0.5">quality</div>
      </div>
    </div>
  );
}

function StepPills({ step, setStep, maxStep }) {
  const items = [
    { i: 1, label: "Type" },
    { i: 2, label: "Describe" },
    { i: 3, label: "Reproduce" },
    { i: 4, label: "Review" },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      {items.map((it) => {
        const locked = it.i > maxStep;
        return (
          <button
            key={it.i}
            onClick={() => !locked && setStep(it.i)}
            disabled={locked}
            className={cn(
              "rounded-full border px-3 py-1.5 text-xs font-semibold transition",
              step === it.i
                ? "bg-white/10 border-white/15 text-white"
                : locked
                ? "bg-white/0 border-white/10 text-white/30 cursor-not-allowed"
                : "bg-white/0 border-white/10 text-white/60 hover:text-white hover:bg-white/5"
            )}
          >
            <span className="mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-black/30 border border-white/10 text-[11px]">
              {it.i}
            </span>
            {it.label}
          </button>
        );
      })}
    </div>
  );
}

function StatusChip({ status }) {
  const s = (status || "new").toString();
  const meta = STATUSES[s] || STATUSES.new;
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2 py-1 text-[11px] font-semibold", meta.className)}>
      {meta.label}
    </span>
  );
}

export default function IssueReportPage() {
  const location = useLocation();
  const user = useSelector((state) => state?.auth?.user);

  const [tab, setTab] = useState("new"); // new | mine
  const [step, setStep] = useState(1);
  const [maxStep, setMaxStep] = useState(1);

  const [myLoading, setMyLoading] = useState(false);
  const [myReports, setMyReports] = useState([]);
  const [q, setQ] = useState("");
  const [selected, setSelected] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const [form, setForm] = useState({
    report_type: "bug",
    severity: "medium",
    title: "",
    description: "",
    steps_to_reproduce: "",
    expected_behavior: "",
    actual_behavior: "",
    feature_area: "",
    full_name: "",
    email: "",
    environment: (import.meta?.env?.MODE || "production") + "",
    app_version: (import.meta?.env?.VITE_APP_VERSION || "").toString(),
  });

  const isAuthed = !!getToken();

  useEffect(() => {
    setForm((p) => ({
      ...p,
      full_name: p.full_name || (user?.first_name ? `${user?.first_name} ${user?.last_name || ""}`.trim() : ""),
      email: p.email || (user?.email || ""),
    }));
  }, [user?.email, user?.first_name, user?.last_name]);

  const page_url = typeof window !== "undefined" ? window.location.href : "";
  const route = location?.pathname || "";

  const context_json = useMemo(() => {
    const w = typeof window !== "undefined" ? window : null;
    return {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locale: (navigator?.language || "").toString(),
      screen: w ? { width: w.screen?.width, height: w.screen?.height } : null,
      viewport: w ? { width: w.innerWidth, height: w.innerHeight } : null,
      referrer: (document?.referrer || "").toString(),
    };
  }, []);

  const qualityScore = useMemo(() => {
    let score = 0;
    if (form.title.trim().length >= 10) score += 25;
    if (form.description.trim().length >= 30) score += 25;
    if (form.steps_to_reproduce.trim().length >= 20) score += 20;
    if (form.expected_behavior.trim().length >= 10) score += 15;
    if (form.actual_behavior.trim().length >= 10) score += 15;
    return Math.min(100, score);
  }, [form]);

  const fingerprint = useMemo(() => {
    const base = [
      form.report_type,
      form.feature_area,
      route,
      form.title.trim().toLowerCase(),
      (form.description || "").trim().toLowerCase().slice(0, 120),
    ].join("|");
    return hashFingerprint(base);
  }, [form.report_type, form.feature_area, route, form.title, form.description]);

  async function loadMine() {
    if (!isAuthed) {
      setMyReports([]);
      setSelected(null);
      return;
    }

    setMyLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/issue-reports/mine`, {
        method: "GET",
        headers: authHeaders(),
        credentials: "include",
      });

      if (res.status === 401) {
        setMyReports([]);
        setSelected(null);
        setMyLoading(false);
        return;
      }

      if (!res.ok) {
        setMyReports([]);
        setSelected(null);
        setMyLoading(false);
        return;
      }

      const data = await res.json();
      const list = data.reports || data.items || data.data || data || [];
      const arr = Array.isArray(list) ? list : [];
      setMyReports(arr);

      if (selected) {
        const selId = selected?.id;
        const next = selId ? arr.find((x) => x.id === selId) : null;
        setSelected(next || null);
      }

      setMyLoading(false);
    } catch {
      setMyReports([]);
      setSelected(null);
      setMyLoading(false);
    }
  }

  useEffect(() => {
    if (tab === "mine") loadMine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  const filteredMine = useMemo(() => {
    const query = q.trim().toLowerCase();
    const list = Array.isArray(myReports) ? myReports : [];
    if (!query) return list;
    return list.filter((r) => {
      const s = `${r.title || ""} ${r.description || ""} ${r.report_type || ""} ${r.severity || ""} ${r.status || ""}`.toLowerCase();
      return s.includes(query);
    });
  }, [myReports, q]);

  const similar = useMemo(() => {
    if (!Array.isArray(myReports) || myReports.length === 0) return [];
    const key = (form.title || "").trim().toLowerCase();
    if (key.length < 6) return [];
    return myReports
      .filter((r) => (r.title || "").toLowerCase().includes(key.slice(0, 6)) || r.fingerprint === fingerprint)
      .slice(0, 2);
  }, [myReports, form.title, fingerprint]);

  function update(k, v) {
    setForm((p) => ({ ...p, [k]: v }));
    setErrorMsg("");
  }

  const canNextFromStep1 = !!form.report_type && !!form.severity;
  const canNextFromStep2 = form.title.trim().length >= 6 && form.description.trim().length >= 20;

  useEffect(() => {
    let m = 1;
    if (canNextFromStep1) m = 2;
    if (canNextFromStep1 && canNextFromStep2) m = 3;
    if (m >= 3) m = 4;
    setMaxStep((prev) => Math.max(prev, m));
  }, [canNextFromStep1, canNextFromStep2]);

  async function submit() {
    setErrorMsg("");
    setSubmitting(true);

    try {
      const payload = {
        full_name: form.full_name || null,
        email: form.email || null,
        report_type: form.report_type,
        severity: form.severity,
        title: form.title.trim(),
        description: form.description.trim(),
        steps_to_reproduce: form.steps_to_reproduce.trim() || null,
        expected_behavior: form.expected_behavior.trim() || null,
        actual_behavior: form.actual_behavior.trim() || null,
        feature_area: form.feature_area.trim() || null,
        page_url,
        route,
        environment: form.environment || "production",
        app_version: form.app_version || null,
        user_agent: (navigator?.userAgent || "").toString(),
        context_json,
        fingerprint,
      };

      const res = await fetch(`${API_BASE}/api/issue-reports`, {
        method: "POST",
        headers: authHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.message || "Failed to submit report");
      }

      const data = await res.json().catch(() => ({}));
      const report = data.report || data.data || data;
      const reportId = report?.id || data?.id || null;

      setSuccess({ id: reportId, fingerprint });

      setForm((p) => ({
        ...p,
        title: "",
        description: "",
        steps_to_reproduce: "",
        expected_behavior: "",
        actual_behavior: "",
      }));

      setStep(1);
      setMaxStep(1);

      setSubmitting(false);

      if (isAuthed) loadMine();
    } catch (e) {
      setSubmitting(false);
      setErrorMsg(e?.message || "Something went wrong");
    }
  }

  return (
    <AppBackground className="min-h-screen bg-[#0B0B12] text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="space-y-2">
            <div className="inline-flex items-center gap-2">
              <div className="h-10 w-10 rounded-2xl border border-white/10 bg-white/5 grid place-items-center">
                <TriangleAlert className="h-5 w-5 text-indigo-300" />
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight">
                  Report an issue <span className="text-white/40">or</span> share feedback
                </h1>
                <p className="text-white/55 text-sm md:text-base">
                  Help us improve InterviewGenieAI. Your report is structured, tracked, and visible in your history.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Pill><ClipboardList className="h-3.5 w-3.5" />Smart report format</Pill>
              <Pill><Zap className="h-3.5 w-3.5" />Auto context captured</Pill>
              <Pill><BadgeCheck className="h-3.5 w-3.5" />Status tracking</Pill>
            </div>
          </div>

          <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-black/20 p-1.5">
            <button
              onClick={() => setTab("new")}
              className={cn(
                "rounded-xl px-4 py-2 text-sm font-semibold transition",
                tab === "new" ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"
              )}
            >
              New report
            </button>
            <button
              onClick={() => setTab("mine")}
              className={cn(
                "rounded-xl px-4 py-2 text-sm font-semibold transition",
                tab === "mine" ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"
              )}
            >
              My reports
            </button>
          </div>
        </div>

        {tab === "mine" ? (
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
            <Card className="lg:col-span-5">
              <div className="p-5 border-b border-white/10 flex items-center justify-between gap-3">
                <div className="space-y-1">
                  <div className="text-sm font-semibold text-white">My reports</div>
                  <div className="text-xs text-white/55">Search, open details, and track status.</div>
                </div>
                <Button variant="ghost" onClick={loadMine} disabled={myLoading || !isAuthed}>
                  {myLoading ? "Refreshing…" : "Refresh"}
                </Button>
              </div>

              <div className="p-5">
                {!isAuthed ? (
                  <div className="rounded-2xl border border-indigo-400/20 bg-indigo-500/10 p-4 text-sm text-indigo-100">
                    <div className="font-semibold">Log in to view your report history</div>
                    <div className="text-xs text-indigo-100/80 mt-1">
                      Your report can still be submitted, but history + status tracking requires an account.
                    </div>
                    <div className="mt-4 flex items-center gap-2">
                      <Link to="/login">
                        <Button>Go to Login <ChevronRight className="h-4 w-4" /></Button>
                      </Link>
                      <Button variant="ghost" onClick={() => setTab("new")}>Create a report</Button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="relative">
                      <Search className="h-4 w-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
                      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by title, status, type…" className="pl-9" />
                    </div>

                    <div className="mt-4 space-y-3">
                      {myLoading ? (
                        <div className="text-white/60 text-sm flex items-center gap-2">
                          <Loader2 className="h-4 w-4 animate-spin" />
                          Loading…
                        </div>
                      ) : filteredMine.length === 0 ? (
                        <div className="rounded-2xl border border-white/10 bg-white/5 p-4 text-sm text-white/70">
                          No reports yet. Create your first one from{" "}
                          <button className="underline" onClick={() => setTab("new")}>
                            New report
                          </button>.
                        </div>
                      ) : (
                        filteredMine.map((r, idx) => {
                          const key = r.id ?? r.fingerprint ?? idx;
                          const selectedKey = selected?.id ?? selected?.fingerprint ?? null;
                          const rowKey = r.id ?? r.fingerprint ?? null;
                          const isSelected = selectedKey && rowKey ? selectedKey === rowKey : false;

                          return (
                            <button
                              key={key}
                              onClick={() => setSelected(r)}
                              className={cn(
                                "w-full text-left rounded-2xl border border-white/10 bg-black/20 hover:bg-white/5 transition p-4",
                                isSelected ? "ring-2 ring-indigo-500/20" : ""
                              )}
                            >
                              <div className="flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                  <div className="text-sm font-semibold text-white truncate">
                                    {r.title || "Untitled report"}
                                  </div>
                                  <div className="mt-1 text-xs text-white/55 overflow-hidden text-ellipsis line-clamp-2">
                                    {r.description || ""}
                                  </div>
                                </div>
                                <div className="flex flex-col items-end gap-2 shrink-0">
                                  <StatusChip status={r.status} />
                                  <Pill className="text-[10px] py-0.5">{(r.severity || "medium").toUpperCase()}</Pill>
                                </div>
                              </div>
                              <div className="mt-3 flex items-center justify-between text-xs text-white/45">
                                <div className="flex items-center gap-2">
                                  <Pill className="bg-white/0">{(r.report_type || "other").toUpperCase()}</Pill>
                                  {r.feature_area && <Pill className="bg-white/0">{r.feature_area}</Pill>}
                                </div>
                                <div>{safeDateLabel(r.created_at)}</div>
                              </div>
                            </button>
                          );
                        })
                      )}
                    </div>
                  </>
                )}
              </div>
            </Card>

            <Card className="lg:col-span-7">
              <div className="p-5 border-b border-white/10 flex items-center justify-between">
                <div className="space-y-1">
                  <div className="text-sm font-semibold text-white">Details</div>
                  <div className="text-xs text-white/55">Full report info and progress.</div>
                </div>
                <Button variant="primary" onClick={() => setTab("new")}>
                  New report <ChevronRight className="h-4 w-4" />
                </Button>
              </div>

              <div className="p-6">
                {!selected ? (
                  <div className="rounded-2xl border border-white/10 bg-white/5 p-6 text-sm text-white/70">
                    Select a report on the left to view details.
                  </div>
                ) : (
                  <div className="space-y-5">
                    <div className="flex items-start justify-between gap-4">
                      <div className="min-w-0">
                        <div className="text-xl font-extrabold text-white">{selected.title}</div>
                        <div className="mt-2 text-sm text-white/65 whitespace-pre-wrap">{selected.description}</div>
                      </div>
                      <div className="flex flex-col items-end gap-2 shrink-0">
                        <StatusChip status={selected.status} />
                        <Pill className="bg-white/0">{(selected.report_type || "other").toUpperCase()}</Pill>
                        <Pill className="bg-white/0">{(selected.severity || "medium").toUpperCase()}</Pill>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
                        <div className="text-xs text-white/55">Created</div>
                        <div className="mt-1 text-sm font-semibold text-white">{safeDateLabel(selected.created_at)}</div>
                      </div>
                      <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
                        <div className="text-xs text-white/55">Feature area</div>
                        <div className="mt-1 text-sm font-semibold text-white">{selected.feature_area || "—"}</div>
                      </div>
                      <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
                        <div className="text-xs text-white/55">Route</div>
                        <div className="mt-1 text-sm font-semibold text-white break-all">{selected.route || "—"}</div>
                      </div>
                      <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
                        <div className="text-xs text-white/55">Resolved</div>
                        <div className="mt-1 text-sm font-semibold text-white">{safeDateLabel(selected.resolved_at)}</div>
                      </div>
                    </div>

                    {(selected.steps_to_reproduce || selected.expected_behavior || selected.actual_behavior) && (
                      <div className="rounded-2xl border border-white/10 bg-black/20 p-4 space-y-3">
                        {selected.steps_to_reproduce && (
                          <div>
                            <div className="text-xs font-semibold text-white/75">Steps</div>
                            <div className="mt-1 text-sm text-white/65 whitespace-pre-wrap">{selected.steps_to_reproduce}</div>
                          </div>
                        )}
                        {selected.expected_behavior && (
                          <div>
                            <div className="text-xs font-semibold text-white/75">Expected</div>
                            <div className="mt-1 text-sm text-white/65 whitespace-pre-wrap">{selected.expected_behavior}</div>
                          </div>
                        )}
                        {selected.actual_behavior && (
                          <div>
                            <div className="text-xs font-semibold text-white/75">Actual</div>
                            <div className="mt-1 text-sm text-white/65 whitespace-pre-wrap">{selected.actual_behavior}</div>
                          </div>
                        )}
                      </div>
                    )}

                    {selected.admin_notes && (
                      <div className="rounded-2xl border border-emerald-400/20 bg-emerald-500/10 p-4">
                        <div className="text-xs font-semibold text-emerald-200">Team note</div>
                        <div className="mt-1 text-sm text-emerald-100/90 whitespace-pre-wrap">{selected.admin_notes}</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Card>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
            <Card className="lg:col-span-7">
              <div className="p-5 border-b border-white/10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="space-y-1">
                  <div className="text-sm font-semibold text-white">Create a report</div>
                  <div className="text-xs text-white/55">Clear reports = faster fixes. We capture context automatically.</div>
                </div>
                <StepPills step={step} setStep={setStep} maxStep={maxStep} />
              </div>

              <div className="p-6 space-y-6">
                {errorMsg && (
                  <div className="rounded-2xl border border-red-400/20 bg-red-500/10 p-4 flex items-start gap-3">
                    <div className="h-10 w-10 rounded-2xl bg-red-500/15 border border-red-400/20 grid place-items-center">
                      <AlertTriangle className="h-5 w-5 text-red-200" />
                    </div>
                    <div className="min-w-0">
                      <div className="text-sm font-semibold text-red-100">Couldn’t submit</div>
                      <div className="text-xs text-red-100/80 mt-1 break-words">{errorMsg}</div>
                    </div>
                  </div>
                )}

                {success && (
                  <div className="rounded-2xl border border-emerald-400/20 bg-emerald-500/10 p-4 flex items-start justify-between gap-3">
                    <div className="flex items-start gap-3">
                      <div className="h-10 w-10 rounded-2xl bg-emerald-500/15 border border-emerald-400/20 grid place-items-center">
                        <BadgeCheck className="h-5 w-5 text-emerald-200" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-emerald-100">Submitted successfully</div>
                        <div className="text-xs text-emerald-100/80 mt-1">
                          Report ID: <span className="font-semibold">{success.id ?? "—"}</span> • Fingerprint:{" "}
                          <span className="font-semibold">{success.fingerprint}</span>
                        </div>

                        {!isAuthed && (
                          <div className="mt-2 text-xs text-emerald-100/80">
                            To track status in <span className="font-semibold">My reports</span>, please{" "}
                            <Link className="underline" to="/login">log in</Link>.
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <Button variant="ghost" onClick={() => setSuccess(null)}>Dismiss</Button>
                      <Button onClick={() => (isAuthed ? setTab("mine") : null)} disabled={!isAuthed}>
                        View history <ChevronRight className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}

                {step === 1 && (
                  <div className="space-y-6">
                    <Field label="What kind of report is this?" hint="Choose the best category. It helps triage.">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {REPORT_TYPES.map((t) => {
                          const Icon = t.icon;
                          const active = form.report_type === t.key;
                          return (
                            <button
                              key={t.key}
                              onClick={() => update("report_type", t.key)}
                              className={cn(
                                "text-left rounded-2xl border p-4 transition",
                                active
                                  ? "border-indigo-400/30 bg-indigo-500/10 shadow-[0_18px_60px_-40px_rgba(99,102,241,0.65)]"
                                  : "border-white/10 bg-black/20 hover:bg-white/5"
                              )}
                            >
                              <div className="flex items-start justify-between gap-3">
                                <div className="flex items-start gap-3">
                                  <div className={cn("h-10 w-10 rounded-2xl grid place-items-center border", active ? "bg-indigo-500/15 border-indigo-400/20" : "bg-white/5 border-white/10")}>
                                    <Icon className={cn("h-5 w-5", active ? "text-indigo-200" : "text-white/70")} />
                                  </div>
                                  <div>
                                    <div className="text-sm font-semibold text-white">{t.label}</div>
                                    <div className="text-xs text-white/55 mt-1">{t.desc}</div>
                                  </div>
                                </div>
                                {active && <BadgeCheck className="h-5 w-5 text-indigo-200" />}
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    </Field>

                    <Field label="Severity" hint="How much does this impact you?">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {SEVERITIES.map((s) => {
                          const active = form.severity === s.key;
                          return (
                            <button
                              key={s.key}
                              onClick={() => update("severity", s.key)}
                              className={cn("text-left rounded-2xl border p-4 transition", active ? "border-white/15 bg-white/10" : "border-white/10 bg-black/20 hover:bg-white/5")}
                            >
                              <div className="flex items-start justify-between gap-3">
                                <div>
                                  <div className="text-sm font-semibold text-white">{s.label}</div>
                                  <div className="text-xs text-white/55 mt-1">{s.hint}</div>
                                </div>
                                {active && <BadgeCheck className="h-5 w-5 text-white/80" />}
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    </Field>

                    <div className="flex items-center justify-end gap-2 pt-2">
                      <Button variant="ghost" onClick={() => setTab("mine")}>View my reports</Button>
                      <Button
                        onClick={() => { if (canNextFromStep1) setStep(2); }}
                        disabled={!canNextFromStep1}
                      >
                        Continue <ChevronRight className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}

                {step === 2 && (
                  <div className="space-y-6">
                    <Field label="Title" hint="Short and specific. Example: “PayPal popup closes after login on Safari”.">
                      <Input value={form.title} onChange={(e) => update("title", e.target.value)} placeholder="Give it a clear title…" />
                    </Field>

                    <Field label="Description" hint="Explain what happened in 2–6 lines. Include what you were trying to do.">
                      <Textarea value={form.description} onChange={(e) => update("description", e.target.value)} placeholder="Describe the issue or feedback…" />
                    </Field>

                    <Field label="Feature area" hint="Optional but helpful. Example: “billing”, “ai-interview”, “resume-builder”." optional>
                      <Input value={form.feature_area} onChange={(e) => update("feature_area", e.target.value)} placeholder="billing / ai-interview / resume-builder …" />
                    </Field>

                    <div className="flex items-center justify-between gap-2 pt-2">
                      <Button variant="ghost" onClick={() => setStep(1)}>Back</Button>
                      <Button
                        onClick={() => { if (canNextFromStep2) setStep(3); }}
                        disabled={!canNextFromStep2}
                      >
                        Continue <ChevronRight className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}

                {step === 3 && (
                  <div className="space-y-6">
                    <Field label="Steps to reproduce" hint="Bullet steps. Example: 1) Go to Billing 2) Click Upgrade 3) …" optional>
                      <Textarea value={form.steps_to_reproduce} onChange={(e) => update("steps_to_reproduce", e.target.value)} placeholder={"1) …\n2) …\n3) …"} />
                    </Field>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Field label="Expected behavior" hint="What should happen?" optional>
                        <Textarea value={form.expected_behavior} onChange={(e) => update("expected_behavior", e.target.value)} placeholder="Expected…" className="min-h-[120px]" />
                      </Field>
                      <Field label="Actual behavior" hint="What happened instead?" optional>
                        <Textarea value={form.actual_behavior} onChange={(e) => update("actual_behavior", e.target.value)} placeholder="Actual…" className="min-h-[120px]" />
                      </Field>
                    </div>

                    <div className="flex items-center justify-between gap-2 pt-2">
                      <Button variant="ghost" onClick={() => setStep(2)}>Back</Button>
                      <Button onClick={() => setStep(4)}>Continue <ChevronRight className="h-4 w-4" /></Button>
                    </div>
                  </div>
                )}

                {step === 4 && (
                  <div className="space-y-6">
                    <div className="rounded-2xl border border-white/10 bg-black/20 p-5">
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <div className="text-sm font-semibold text-white">Review</div>
                          <div className="text-xs text-white/55 mt-1">Better details = faster fix.</div>
                        </div>
                        <Pill className="font-mono">{fingerprint}</Pill>
                      </div>

                      <div className="mt-4 space-y-3">
                        <div className="flex flex-wrap items-center gap-2">
                          <Pill className="bg-white/0">{form.report_type.toUpperCase()}</Pill>
                          <Pill className="bg-white/0">{form.severity.toUpperCase()}</Pill>
                          {form.feature_area && <Pill className="bg-white/0">{form.feature_area}</Pill>}
                        </div>

                        <div className="text-lg font-extrabold text-white">{form.title || "—"}</div>
                        <div className="text-sm text-white/65 whitespace-pre-wrap">{form.description || "—"}</div>
                      </div>
                    </div>

                    <div className="flex items-center justify-between gap-2 pt-2">
                      <Button variant="ghost" onClick={() => setStep(3)}>Back</Button>
                      <Button
                        loading={submitting}
                        onClick={submit}
                        disabled={submitting || form.title.trim().length < 6 || form.description.trim().length < 20}
                      >
                        Submit report <Send className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Card>

            <div className="lg:col-span-5 space-y-6">
              <Card>
                <div className="p-5 border-b border-white/10 flex items-center justify-between gap-3">
                  <div className="space-y-1">
                    <div className="text-sm font-semibold text-white">Report quality</div>
                    <div className="text-xs text-white/55">Higher quality = faster resolution.</div>
                  </div>
                  <Pill className="font-mono">{fingerprint}</Pill>
                </div>
                <div className="p-6 flex items-center gap-6">
                  <ProgressRing value={qualityScore} />
                  <div className="space-y-2">
                    <div className="text-sm font-semibold text-white">Tips</div>
                    <div className="text-xs text-white/60 space-y-1">
                      <div className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-indigo-400/80" /><span>Add steps + expected/actual to boost clarity.</span></div>
                      <div className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-indigo-400/80" /><span>Mention device/browser if it matters.</span></div>
                      <div className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-indigo-400/80" /><span>Keep title short + specific.</span></div>
                    </div>
                  </div>
                </div>
              </Card>

              <div className="flex items-center justify-between">
                <Link to="/dashboard-home" className="text-sm text-white/60 hover:text-white transition">← Back to dashboard</Link>
                <Button variant="ghost" onClick={() => setTab("mine")}>My reports <ChevronRight className="h-4 w-4" /></Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AppBackground>
  );
}
